export default {
  paymentManagement: "Төлбөрийн брэндийн удирдлага",
  newpayment: "Шинээр хүсэлт илгээх",
  nowUsing: "ашиглагдаж байгаа",
  tipsForApplyingWallet:
    "MARS системд нэвтэрч төлбөрийн нэмэлт брэнд авах хүсэлт гаргана уу. Хэрэв та нэвтрэх дансаа мэдэхгүй бол хэрэглэгчийн дэмжлэгтэй холбоо барина уу (03-4589-7746).",
  tipsForRmApplyingWallet:
    "Хэрэв та төлбөрийн брэнд нэмэхийг хүсч байвал Бүс нутгийн маркетинг (011-215-1002) -тай холбогдоно уу."
};
